import React from 'react'
import PropTypes from 'prop-types'
import { Typography, Divider, Card, CardHeader, Avatar, makeStyles, Switch } from '@material-ui/core'
import PollIcon from '@material-ui/icons/Poll'
import Questions from './Questions'

const ServiceChecklists = (props) => {
	const classes = ServiceChecklistsStyles()
	//objects props section
	const { onChecklistResponse, onSetChecklistApplicability } = props

	//Functions props section
	const { checklists, service } = props
	//bool props section
	const { canBeAddedResponse, isVisibleMessageChecklisAppicable, isSaving } = props
	return (
		<div className={classes.container}>
			{service && isVisibleMessageChecklisAppicable && (
				<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
					{/* <div className={classes.emptyStateContainer}> */}
					<Typography variant='body2' color='textSecondary' align='center'>
						Por favor activa la encuesta para este servicio. En caso de que no aplique la encuesta continuea con el siguiente paso.
					</Typography>
					{canBeAddedResponse && (
						<Switch
							checked={service?.IsChecklistApplicable}
							onChange={(e) => onSetChecklistApplicability(!service?.IsChecklistApplicable)}
							disabled={isSaving}
						/>
					)}
				</div>
			)}

			{checklists && (
				<Card className={classes.card}>
					<CardHeader
						avatar={
							<Avatar className={classes.avatar}>
								<PollIcon fontSize='small' />
							</Avatar>
						}
						title={
							<Typography variant='subtitle1' color='primary'>
								{checklists.Title}
							</Typography>
						}
					/>
				</Card>
			)}

			{service &&
				service.IsChecklistApplicable &&
				checklists &&
				checklists.Sections.map((section, sectionIndex) => {
					return (
						<Card className={classes.sectionCard}>
							<CardHeader
								className={classes.sectionCardHeader}
								title={<Typography variant='subtitle1'>{`${sectionIndex + 1}. ${section.Title}`}</Typography>}
								subheader={
									<Typography variant='subtitle2' color='textSecondary'>
										{section.Description}
									</Typography>
								}
								style={{
									padding: 5
								}}
							/>
							<Divider />
							<Questions
								canBeAddedResponse={canBeAddedResponse}
								//objects
								section={section}
								checklistResponse={service?.ChecklistResponse}
								// //functions
								onChecklistResponse={onChecklistResponse}
								// bool props
								isSaving={isSaving}
							/>
						</Card>
					)
				})}
		</div>
	)
}

export const ServiceChecklistsStyles = makeStyles((theme) => ({
	container: {
		padding: '5px',
		backgroundColor: '#f9f9f9'
	},
	card: {
		marginBottom: '5px',
		borderRadius: '8px',
		boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
		padding: 0,
		'&:last-child': {
			paddingBottom: 0
		}
	},
	avatar: {
		backgroundColor: theme.palette.primary.main
	},
	sectionCard: {
		marginBottom: '5px',
		borderRadius: '8px',
		boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)'
	},
	questionBlock: {
		marginTop: '16px'
	},
	questionTitle: {
		fontWeight: 'bold'
		// marginBottom: '8px',
	},
	sectionCardHeader: {
		backgroundColor: theme.palette.serviceStatus.newServiceDark,
		color: theme.palette.common.white
	},
	emptyStateContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		padding: '5px',
		backgroundColor: '#fff',
		borderRadius: '8px',
		boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
		marginTop: '16px'
	},
	addSectionButton: {
		marginTop: '16px',
		textTransform: 'none',
		fontSize: '1rem'
	}
}))

ServiceChecklists.propTypes = {
	serie: PropTypes.shape({
		Serie: PropTypes.string,
		Model: PropTypes.string
	}),
	onSave: PropTypes.func.isRequired
}

export default ServiceChecklists
